<script>

	import { onMount } from 'svelte';
	import { createEventDispatcher } from 'svelte';

	import { fade, slide } from 'svelte/transition';

    import Applications from '../services/applications'
    import { notifications } from '../services/notification'
  	
	const dispatch = createEventDispatcher()

    let application = { name : "Sans nom"}
    let applicationId = null
	let visible = false

    let mode = "creation"

    onMount(async () => {})

    const update = async () => {

        let updatedApp = {}
        if(application.name) updatedApp.name = application.name
        if(application.description) updatedApp.description = application.description
        if(application.icon) updatedApp.icon = application.icon
        if(application.main_url) updatedApp.main_url = application.main_url
        if(application.help_url) updatedApp.help_url = application.help_url
        if(application.group) updatedApp.group = application.group

        updatedApp.is_active = application.is_active
        
        let aresult = await Applications.updateOneApplication(applicationId, updatedApp)
        if(aresult.success) application = aresult.data
        if(!aresult.success) notifications.danger(aresult.data.message)

        stop('update', aresult)
    }
    
    const create = async () => {

        let createdApp = {}
        if(application.name) createdApp.name = application.name
        if(application.description) createdApp.description = application.description
        if(application.icon) createdApp.icon = application.icon
        if(application.main_url) createdApp.main_url = application.main_url
        if(application.help_url) createdApp.help_url = application.help_url
        if(application.is_active) createdApp.is_active = application.is_active
        if(application.group) createdApp.group = application.group

        let aresult = await Applications.createOneApplication(createdApp)
        if(aresult.success) {
            application = aresult.data
            stop('create', aresult)
        }
        if(!aresult.success) notifications.danger(aresult.data.message)

        
        
    }

    const remove = async () => {

        let aresult = await Applications.deleteOneApplication(applicationId)
        if(aresult.success) application = aresult.data
        if(!aresult.success) notifications.danger(aresult.data.message)

        stop('delete', aresult)

    }

	export const start = async (uid = null) => {
        if(uid) {
            mode = "modification"
            applicationId = uid
            let aresult = await Applications.getOneApplication(applicationId)
            if(aresult.success) application = aresult.data
        } else {
            mode = "creation"
        }

		visible = true
	}

	export const stop = (action = 'close', data = {}) => {
		dispatch('message', {
			action : action,
            data : data
		})
        application = { name : "Sans nom"}
        applicationId = null
		visible = false
	}

	const handleClose = () => {
		stop()
	}

</script>

{#if visible}
    <div class="fullscreen" on:click={handleClose} transition:fade="{{ y: 200, duration: 200 }}"></div>
    <div class="container main-modal" transition:slide="{{ x: -200, duration: 200 }}">
        <div class="row p-0 m-0">
            <div class="col p-0 m-0"></div>
            <div class="col-auto p-0 m-0">
                <button type="button" class="btn-close" aria-label="Close" on:click="{stop}"></button>
            </div>
        </div>        
        <div class="row justify-content-center">
            <div class="col-md-12">

                <h2 class="text-center" id="users">{application.name} </h2>
                
                <div class=" mt-4">
                    <input type="text" bind:value={application.name} class="p-2 w-100" placeholder="Nom"/>
                </div>
    
                <div class=" mt-4">
                    <input type="text" bind:value={application.icon} class="p-2 w-100" placeholder="Icône"/>
                </div>
    
                <div class=" mt-4">
                    <input type="text" bind:value={application.description} class="p-2 w-100" placeholder="Description"/>
                </div>
    
                <div class=" mt-4">
                    <input type="text" bind:value={application.main_url} class="p-2 w-100" placeholder="URL principale"/>
                </div>
    
                <div class=" mt-4">
                    <input type="text" bind:value={application.help_url} class="p-2 w-100" placeholder="URL d'accès à l'aide"/>
                </div>

                <div class=" mt-4">
                    <input type="text" bind:value={application.group} class="p-2 w-100" placeholder="Groupe"/>
                </div>

                <div class="mt-4">
                    <label class="text-left">
                        <input type=checkbox bind:checked={application.is_active}>
                        Visibilité de l'application
                    </label>
                </div>
            
            </div>    
        </div>
        <div class="row justify-content-center">
            <div class="col-md-6 text-center">
                {#if mode === "modification"}
                    <div class=" mt-4">
                        <button type="button" on:click={update} class="btn btn-dark w-100">Mettre à jour</button>
                    </div>
                {:else}
                    <div class=" mt-4">
                        <button type="button" on:click={create} class="btn btn-dark w-100">Créer</button>
                    </div>
                {/if}  
            </div>
            <div class="col-md-6 text-center">
                <div class=" mt-4">
                    <button type="button" on:click={remove} class="btn btn-danger w-100">Supprimer</button>
                </div>    
            </div>
        </div>
    </div>
{/if}

<style>

    .fullscreen {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom : 0;
        background-color: rgba(0, 0, 0, 0.33);
    }

	.main-modal {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: white;
        border-radius: 15px;
        max-width: 100%;
        padding: 10px 35px 35px 35px;
        max-height: 100%;
        width: 500px;
        overflow: auto;
	}

</style>
